import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import Header from "../headers/light.js";
import HeadingText from "./HeadingText.js";
import OurSchoolClients from "../clients/Schools.js";
import { LinkButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as ArrowForward } from "images/arrowForward.svg";


const Container = tw.div`relative px-4 lg:px-0`; // Consistent padding, adjusts on larger screens
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-start max-w-screen-xl mx-auto pt-8 pb-2 lg:py-2`; // Consistent padding, aligns items to start
const LeftColumn = tw.div`relative ml-4 lg:w-6/12 text-left`; // Left-aligned text
const RightColumn = tw.div`relative mt-8 lg:mt-0 lg:w-6/12 flex flex-col justify-center lg:self-end`; // Added width for right column

const Heading = tw.h1`font-bold text-2xl md:text-3xl lg:text-4xl text-black leading-tight mb-4`; // Improved heading styling, margin bottom
const Paragraph = tw.p`my-4 text-base xl:text-lg text-left`; // Consistent margin, left-aligned text
const Text = tw.p`my-2 text-base xl:text-lg font-semibold`;
const TextNew = tw.p`my-2 text-base xl:text-lg`; // Consistent margin
const Actions = styled.div`
  ${tw`relative w-full lg:w-auto`} // Full width on mobile, auto on larger screens
  button {
    ${tw`w-full bg-secondary-600 text-gray-100 my-4 py-4 flex items-center justify-center sm:w-auto sm:px-6 sm:py-3 focus:outline-none hover:bg-secondary-900 transition duration-300 rounded-lg`} // Full width button, rounded corners, responsive padding
  }
`;

const IllustrationContainer = tw.div`flex justify-center items-center`; // Center image on mobile
const Gtext = tw.span`text-brand-400`;
const Ltext = tw.span`text-brand-400 font-bold`;

const ClientSection = tw.section`text-center mt-8 mb-10`; // Increased margin
const UpcomingBlock = tw.div`py-4`;
const BatchHead = tw.h3`text-left text-xl text-blue-700 font-bold`;
const BatchLink = tw.a`text-center px-4 py-2 bg-[#ccdff2] mr-2 text-blue-700 rounded-sm font-semibold inline-block my-2`; // Added inline-block and margin
const IconContainer = tw.i``;
const Content = tw.p`text-blue-700 font-bold !text-lg inline-block rounded-full`;
const Highlight = tw.span`text-left text-base xl:text-lg text-[#dc3188] font-bold px-2`;
const LinkButton = styled(PrimaryButtonBase)(props => [
  tw`bg-brand-700 hover:bg-brand-500 hover:text-white mt-4 text-sm w-full lg:w-auto inline-block rounded-full text-white p-2 px-5`, // Full width on mobile, responsive margin
  props.buttonRounded && tw`rounded-full`
]);

export default ({ 
  roundedHeaderButton,
  mainTitle='',
  subTitle='',
  paragraph='',
  imageSrc='',
  buttonText='',
  buttonUrl='https://wa.me/918920403902/?text=Hi, I want to register for FREE Live Test & Discussion with YoungMinds...', 
  showClient= true,
  text,
  knowmoreUrl,
  buttonRounded = false,
}) => {
  return (
    <>
      <Header roundedHeaderButton={roundedHeaderButton} />
      <Container>
        <TwoColumn>
        <RightColumn>
            <IllustrationContainer>
              <img tw="min-w-0 w-full max-w-lg xl:max-w-3xl" src={imageSrc} alt="Design Illustration" />
            </IllustrationContainer>
          </RightColumn>
          <LeftColumn>
            {mainTitle && (
              <Heading>
              {mainTitle}
              </Heading>
            )}
            <TextNew>
            <p>
            {subTitle}
            </p>
            </TextNew>
            <UpcomingBlock>
            <Text>
              {paragraph}
            </Text>
            {knowmoreUrl &&(
              <LinkButton  className="exploreBtn" as="a" href={knowmoreUrl}>
                <Content>Click Here - to Know More About <Highlight>{text} Coaching Program</Highlight></Content>
              </LinkButton>
            )}
            </UpcomingBlock>
            <LinkButton buttonRounded={buttonRounded} className="exploreBtn" as="a" href={buttonUrl}>
                {buttonText} <IconContainer><ArrowForward className="btnArrow" /></IconContainer>
              </LinkButton>
          </LeftColumn>
          
        </TwoColumn>
        {showClient == true && (
          <>
            <HeadingText />
            <ClientSection>
              <OurSchoolClients />
            </ClientSection>
          </>
        )}
      </Container>
    </>
  );
};
